import './App.css';
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import EES from "./Components/EES/EES";
import Validador from "./Components/Validador/Validador";
import M2M from "./Components/M2M/M2M";
import Fus from "./Components/Fus/Fus";
import Fas from "./Components/Fas/Fas";
import Contingencias from "./Components/Contingencias/Contingencias";
import ContingenciasReject from "./Components/Contingencias/ContingenciasReject";
import ContingenciasList from "./Components/Contingencias/ContingenciasList";
import ContingenciasPreview from "./Components/Contingencias/ContingenciasPreview";
import ConsultaS from "./Components/ConsultaS/ConsultaS";
import ConsultaM from "./Components/ConsultaM/ConsultaM";
import NotFound from "./Components/NotFound/NotFound";
import DrawerBase from './Components/Drawer/Drawer';
import SignIn from './Components/Login/SignIn';
import Test from './Components/AuthT/AuthT';
import RequireAuth from './hooks/RequireAuth';
import ProtectedRoute from './hooks/ProtectedRoute';
import ContextProvider from './Components/GeneralContext/ContextProvider';
import { SnackbarProvider } from "./Components/GeneralContext/SnackbarContext";
import UUID from "./Components/UUID/UUID";
import Support from "./Components/Support/Support";
import Home from "./Components/Home/Home";
import UserConf from "./Components/Configuracion/Configuracion";
import GobStyle from './styles/GobStyle';
import FasList from './Components/Fas/FasList';
import FasFirma from './Components/Fas/FasFirma';
import FasReject from './Components/Fas/FasReject';
import FasPreview from './Components/Fas/FasPreview';
import FusList from './Components/Fus/FusList';
import FusReject from './Components/Fus/FusReject';
import FusFirma from './Components/Fus/FusFirma';
import FusPreview from './Components/Fus/FusPreview';
import ContingenciasFirma from './Components/Contingencias/ContingenciasFirma';
import ContingenciasPendientesList from './Components/Contingencias/ContingenciasPendientesList';


import PeriodoGracia from "./Components/PeriodoGracia/PeriodoGracia";


import ContingenciasOverwrite from './Components/Contingencias/ContingenciasOverwrite';
import Monitoreo from './Components/Reports/Monitoreo';
import ReportesPrincipal from './Components/Reports/ReportesPrincipal';
import Tendencias from './Components/Reports/Tendencias';
import PrefacturaList from './Components/Prefactura/PrefacturaList';
import BajasPorOperador from './Components/Prefactura/BajasPorOperador';
import InicioObrasPorOperador from './Components/Prefactura/InicioObrasPorOperador';
import InicioServicioPorOperador from './Components/Prefactura/InicioServicioPorOperador';
import PrefacturaDetails from './Components/Prefactura/PrefacturaDetails';
import PrefacturaRBD from './Components/Prefactura/PrefacturaRBD';
import Apelacion from './Components/Prefactura/Apelacion';
import ApelacionValidacion from './Components/Prefactura/ApelacionValidacion';
import ApelacionPreview from './Components/Prefactura/ApelacionPreview';
import ApelacionesList from './Components/Prefactura/ApelacionesList';
import ParqueList from './Components/Parque/ParqueList';
import ParqueRecepcion from './Components/Parque/ParqueRecepcion';
import ParqueInicio from './Components/Parque/ParqueInicio';
import ParqueBaja from './Components/Parque/ParqueBaja';
import ParqueTech from './Components/Parque/ParqueTech';
import ParqueNYA from './Components/Parque/ParqueNYA';


import AlarmList from './Components/Alarms/AlarmList';
import AlarmDetail from './Components/Alarms/AlarmDetail';
import EstablecimientoEdit from './Components/Parque/EstablecimientoEdit';
import EstablecimientoPreview from './Components/Parque/EstablecimientoPreview';
import RbdList from './Components/RBD/RbdList';

import CheckFile from './Components/CheckFile/CheckFile';
import PrefacturaHistory from './Components/Reports/PrefacturaHistory'
import OPReport from './Components/Reports/OPReport'
import RepresentantesList from './Components/Representantes/RepresentantesList';
import DireccionesList from './Components/RBD/DireccionesList';
import AdminAltas from './Components/utils/AdminAltas';
import AdminBajas from './Components/utils/AdminBajas';



function App() {
  return (
    <div>
      <BrowserRouter>
        <GobStyle>
        <SnackbarProvider>
          <ContextProvider>
            <DrawerBase>
              <Routes>


              
                <Route path="*" element={<NotFound />} />
                <Route path="/login" element={<SignIn />} />
                <Route path="/" element={<Navigate replace to="/login" />} />
           
                
                <Route element={<RequireAuth />}>


                  <Route path="/contingencias" element={<ProtectedRoute requiredResource="/contingencias"><Contingencias />  </ProtectedRoute>} />
                  <Route path="/periodo_gracia" element={<ProtectedRoute requiredResource="/periodo_gracia"><PeriodoGracia />  </ProtectedRoute>} />


                  <Route path="/fas_validacion" element={<ProtectedRoute requiredResource="/fas_validacion"> <Validador /> </ProtectedRoute>} />
                  <Route path="/fas_lista" element={<ProtectedRoute requiredResource="/fas_lista"> <FasList /> </ProtectedRoute>} />
                  <Route path="/fus" element={<ProtectedRoute requiredResource="/fus"> <Fus /> </ProtectedRoute>} />
                  <Route path="/fus_lista" element={<ProtectedRoute requiredResource="/fus_lista"> <FusList /> </ProtectedRoute>} />
                  <Route path="/fas" element={<ProtectedRoute requiredResource="/fas"> <Fas /> </ProtectedRoute>} />
                  <Route path="/uuid" element={<ProtectedRoute requiredResource="/uuid"> <UUID /> </ProtectedRoute>} />
                  <Route path="/configuracion" element={<UserConf />} />
                  <Route path="/ayuda" element={<Support />} />
                  <Route path="/home" element={<Home />} />
                  <Route path="/test_auth" element={<Test />} />

                  <Route path="/contingencias_lista" element={<ProtectedRoute requiredResource="/contingencias_lista"> <ContingenciasList /> </ProtectedRoute>}  />
                  <Route path="/contingencias_detalle/:id" element={<ProtectedRoute requiredResource="/contingencias_lista"><ContingenciasPreview />  </ProtectedRoute>} />
                  <Route path="/fas_firma/:id" element={<ProtectedRoute requiredResource="/fas_lista"><FasFirma />  </ProtectedRoute>} />
                  <Route path="/fus_firma/:id" element={<ProtectedRoute requiredResource="/fus_lista"><FusFirma />  </ProtectedRoute>} />
                  <Route path="/fas_detalle/:id" element={<ProtectedRoute requiredResource="/fas_lista"><FasPreview />  </ProtectedRoute>} />
                  <Route path="/fus_detalle/:id" element={<ProtectedRoute requiredResource="/fus_lista"><FusPreview />  </ProtectedRoute>} />
                  <Route path="/contingencias_rechazar/:id" element={<ProtectedRoute requiredResource="/contingencias_rechazar"><ContingenciasReject />  </ProtectedRoute>} />
                  <Route path="/fas_rechazar/:id" element={<ProtectedRoute requiredResource="/fas_rechazar"><FasReject />  </ProtectedRoute>} />

                  <Route path="/fus_rechazar/:id" element={<ProtectedRoute requiredResource="/fus_rechazar"><FusReject />  </ProtectedRoute>} />

                  <Route path="/contingencias_firma/:id" element={<ProtectedRoute requiredResource="/contingencias_lista"><ContingenciasFirma />  </ProtectedRoute>} />

                  <Route path="/contingencias_overwrite/:id" element={<ProtectedRoute requiredResource="/admin"><ContingenciasOverwrite />  </ProtectedRoute>} />

                  <Route path="/periodo_gracia" element={<ProtectedRoute requiredResource="/periodo_gracia"> <PeriodoGracia /> </ProtectedRoute>}  />
                   <Route path="/prefactura" element={<ProtectedRoute requiredResource="/prefactura"> <PrefacturaList /> </ProtectedRoute>}  />


                   <Route path="/lista_bajas" element={<ProtectedRoute requiredResource="/prefactura"> <BajasPorOperador /> </ProtectedRoute>}  />
                   <Route path="/lista_altas" element={<ProtectedRoute requiredResource="/prefactura"> <InicioServicioPorOperador /> </ProtectedRoute>}  />
                   <Route path="/lista_recepcion_obras" element={<ProtectedRoute requiredResource="/prefactura"> <InicioObrasPorOperador /> </ProtectedRoute>}  />


                   
                   <Route path="/prefactura_detalle/:id" element={<ProtectedRoute requiredResource="/prefactura"> <PrefacturaDetails /> </ProtectedRoute>}  />
                   <Route path="/prefactura_detalle/:id/:periodo" element={<ProtectedRoute requiredResource="/prefactura"> <PrefacturaDetails /> </ProtectedRoute>}  />

                   <Route path="/prefactura_rbds" element={<ProtectedRoute requiredResource="/prefactura_rbds"> <PrefacturaRBD /> </ProtectedRoute>}  />
                  <Route path="/apelacion_validacion/:id" element={<ProtectedRoute requiredResource="/prefactura"><ApelacionValidacion/> </ProtectedRoute>} />
                  <Route path="/devengo_validacion/:id" element={<ProtectedRoute requiredResource="/prefactura"><ApelacionValidacion/> </ProtectedRoute>} />

                   <Route path="/apelacion_detalle/:id" element={<ProtectedRoute requiredResource="/apelaciones_lista"> <ApelacionPreview /> </ProtectedRoute>}  />
                   <Route path="/devengo_detalle/:id" element={<ProtectedRoute requiredResource="/apelaciones_lista"> <ApelacionPreview /> </ProtectedRoute>}  />

                   <Route path="/prefactura_detalle" element={<ProtectedRoute requiredResource="/prefactura_detalle"> <PrefacturaDetails /> </ProtectedRoute>}  />
                  <Route path="/apelacion/:periodo" element={<ProtectedRoute requiredResource="/prefactura_detalle"><Apelacion />  </ProtectedRoute>} />
                  <Route path="/devengo/:periodo" element={<ProtectedRoute requiredResource="/prefactura_detalle"><Apelacion />  </ProtectedRoute>} />
                   <Route path="/apelaciones_lista" element={<ProtectedRoute requiredResource="/apelaciones_lista"><ApelacionesList /> </ProtectedRoute> } />
                   <Route path="/establecimiento_modificar/:id" element={<ProtectedRoute requiredResource="/fas_lista"><EstablecimientoEdit />  </ProtectedRoute>} />
                   <Route path="/establecimiento_detalle/:id" element={<ProtectedRoute requiredResource="/fas_lista"><EstablecimientoPreview />  </ProtectedRoute>} />


                  <Route path="/verificador" element={<CheckFile />} />
                  <Route path="/supervision_operador" element={<ProtectedRoute requiredResource="/supervision_operador"><OPReport /></ProtectedRoute>} />
                  <Route path="/prefactura_historial" element={<ProtectedRoute requiredResource="/prefactura_historial"><PrefacturaHistory/>  </ProtectedRoute>} /> 

                  <Route path="/parque_lista" element={<ProtectedRoute requiredResource="/parque_lista"><ParqueList/>  </ProtectedRoute>} />
                  <Route path="/alarmas_lista" element={<ProtectedRoute requiredResource="/alarmas_lista"><AlarmList/>  </ProtectedRoute>} />
                  <Route path="/alarma_detalle/:id" element={<ProtectedRoute requiredResource="/alarmas_lista"><AlarmDetail/>  </ProtectedRoute>} />
                  <Route path="/representantes_lista" element={<ProtectedRoute requiredResource="/representantes_lista"><RepresentantesList/>  </ProtectedRoute>} />
                  <Route path="/rbd_lista" element={<ProtectedRoute requiredResource="/rbd_lista"><RbdList/>  </ProtectedRoute>} />
                  <Route path="/direcciones_validacion" element={<ProtectedRoute requiredResource="/direcciones_validacion"><DireccionesList/>  </ProtectedRoute>} />
                  <Route path="/parque_recepcion" element={<ProtectedRoute requiredResource="/parque"><ParqueRecepcion/>  </ProtectedRoute>} />
                  <Route path="/parque_inicio" element={<ProtectedRoute requiredResource="/parque"><ParqueInicio/>  </ProtectedRoute>} />
                  <Route path="/parque_baja" element={<ProtectedRoute requiredResource="/parque"><ParqueBaja/>  </ProtectedRoute>} />
                  <Route path="/parque_tecnologia" element={<ProtectedRoute requiredResource="/parque"><ParqueTech/>  </ProtectedRoute>} />
                  <Route path="/agregar_rbd" element={<ProtectedRoute requiredResource="/parque"><ParqueNYA/>  </ProtectedRoute>} />


                  <Route path="/reportes/*" element={<ProtectedRoute requiredResource="/supervision_operador"><ReportesPrincipal /></ProtectedRoute>} />


                  <Route path="/contingencias_pendientes" element={<ProtectedRoute requiredResource="/contingencias"><ContingenciasPendientesList/>  </ProtectedRoute>} />





                </Route>
              </Routes>
            </DrawerBase>
          </ContextProvider>
          </SnackbarProvider>
        </GobStyle>
      </BrowserRouter>
    </div>
  );
}


export default App;
